import React from 'react'

import { TruncateWithTooltip, WorkspaceLogo } from '@sketch/components'

import {
  NotificationDescription,
  NotificationShareName,
  NotificationBody,
  NotificationAvatarWrapper,
} from '../NotificationListItem.styles'

import { WorkspaceInvitedNotificationFragment } from '@sketch/gql-types'

// Workspace invites can't be safely accepted inline — AcceptWorkspaceInviteView
// branches on partner role, SSO state, and account/email mismatch. The whole
// card already links to notification.path (= the accept-invite landing page),
// which handles all of that, so no inline Accept button here.

interface WorkspaceInvitedNotificationListItemProps {
  notification: WorkspaceInvitedNotificationFragment
}

const WorkspaceInvitedNotificationListItem: React.FCC<
  WorkspaceInvitedNotificationListItemProps
> = ({ notification }) => {
  const workspaceName = notification.workspace?.name ?? notification.title

  return (
    <>
      <NotificationShareName data-testid="notification-share-name">
        <TruncateWithTooltip>{workspaceName}</TruncateWithTooltip>
      </NotificationShareName>
      <NotificationBody data-testid="notification-body">
        <NotificationAvatarWrapper>
          <WorkspaceLogo
            workspaceName={workspaceName}
            src={notification.workspace?.avatar?.small}
            size="17px"
          />
        </NotificationAvatarWrapper>
        <NotificationDescription data-testid="notification-description">
          {notification.subtitle}
        </NotificationDescription>
      </NotificationBody>
    </>
  )
}

export default WorkspaceInvitedNotificationListItem
